<template>
    <section>
        <div class="page">
            <div>
                <h2>Changing your phone number</h2>
                <p>
                    The <strong>Change Number</strong> feature allows you to change the phone number associated with
                    your ToTok
                    account on your same phone. This feature is intended to be used before you verify your new number.
                </p>
                <h3>Before beginning the Change Number process</h3>
                <ul>
                    <li>Make sure your new phone number can receive SMS and has an active data connection.
                    </li>
                    <li>Make sure your old phone number is currently verified in ToTok on your phone. You can see what
                        number is
                        verified in ToTok by navigating to <strong>ToTok</strong> > <strong>Me</strong>.
                    </li>
                </ul>
                <h3>To change your phone number within ToTok</h3>
                <ol>
                    <li>Go to <strong>Me > Account > Change Number</strong>.
                    </li>
                    <li>Enter your password. Tap <strong>Confirm</strong>.</li>
                    <li>Enter your new phone number in full international format.</li>
                    <li>Tap <strong>Next</strong>.</li>
                    <li>Complete the process by <a href="https://totok.ai/faq/android/10201">verifying your new phone
                        number</a>.
                    </li>
                </ol>
                <h6><i>Note: By changing phone number, your contact, group, and personal information linked with current
                    account
                    will be transferred to the new account. Changing phone number will cause a loss of message history.
                </i></h6>


            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
